"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GSlidesIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var withSVGIcon_1 = require("../withSVGIcon");
var Icon = function () { return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsxs("g", __assign({ clipPath: "url(#clip0)" }, { children: [jsx_runtime_1.jsx("path", { d: "M19.0682 24H4.88636C3.98636 24 3.25 23.2636 3.25 22.3636V1.63636C3.25 0.736364 3.98636 0 4.88636 0H14.7045L20.7045 6V22.3636C20.7045 23.2636 19.9682 24 19.0682 24Z", fill: "#F8BF08" }, void 0),
                jsx_runtime_1.jsx("path", { d: "M14.7046 0L20.7046 6H14.7046V0Z", fill: "#F59307" }, void 0),
                jsx_runtime_1.jsx("path", { d: "M6.52274 9.40906V17.0454H17.4318V9.40906H6.52274ZM16.0682 15.6818H7.88637V10.7727H16.0682V15.6818Z", fill: "#FDFFFF" }, void 0)] }), void 0),
        jsx_runtime_1.jsx("defs", { children: jsx_runtime_1.jsx("clipPath", __assign({ id: "clip0" }, { children: jsx_runtime_1.jsx("rect", { width: "17.4545", height: "24", fill: "white", transform: "translate(3.25)" }, void 0) }), void 0) }, void 0)] }, void 0)); };
exports.GSlidesIcon = withSVGIcon_1.withSVGIcon(Icon, { viewBox: '0 0 24 24' });
//# sourceMappingURL=GSlidesIcon.js.map